import "./SolutionsSubpages.module.css";
import Header from "@/reusable_sections/Header";
import PatioDoorRepairServicesInSaintBasileLeGrand from "./sections/PatioDoorRepairServicesInSaintBasileLeGrand";
import PracticeByNature from "./sections/PracticeByNature";
import KontaktCta from "./sections/KontaktCta";
import StorytellingApproach from "./sections/StorytellingApproach";
import WordFromTheField from "./sections/WordFromTheField";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsSubpagesPage() {
  return <div>
      <Header />
      <PatioDoorRepairServicesInSaintBasileLeGrand />
      <PracticeByNature />
      <StorytellingApproach />
      <WordFromTheField />
      <KontaktCta />
      <Footer />
    </div>;
}